var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { agreementsCommon, baseCommon, configCommon, merchantCommon, } from '@repo/api/endpoints/merchant/msw/mocks/common';
export var WIDGET_HAS_OVER_3000_LIMIT_AND_NO_LOAN_APPLICATION = __assign(__assign({}, baseCommon), { type: 'IFRAME_MERCHANT_SUMMARY', currentProvider: ['pragma'], data: {
        merchantData: __assign(__assign({}, merchantCommon), { user: {
                type: 'user',
                userId: 12345,
                permission: {
                    widget: true,
                    newLoan: true,
                    cancelLoan: true,
                    continueLoan: true,
                },
                accessFor: ['193421', '1234', '4321'],
            } }),
        preLimits: [],
        limits: [
            {
                id: 1732011441,
                preLimitId: 1732011441,
                min: 4000,
                max: 50000,
                used: 48000,
                currency: 'PLN',
                provider: 'pragma',
                availableLimitRevenueRate: [
                    {
                        period: 12,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                    {
                        period: 6,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                ],
                minMaxDifference: false,
                available: 5000,
            },
        ],
        loans: [
            {
                id: 53,
                limitId: 18,
                amount: 150000,
                currency: 'PLN',
                period: 12,
                pricing: 17.5,
                loanRepaymentPrice: 13.93,
                name: 'LOAN_ADVANCE',
                iban: 'PL80109013040000000131651320',
                createdAt: '2024-11-19 09:19:44',
                provider: 'pragma',
                stage: 6,
                providerRequest: 'gotNotification',
                sms: [],
                loanRepaymentAccounts: [263534],
                previousStage: 2,
                documents: [
                    {
                        url: 'http://fso.loantest.qa.pragmago.tech/api/partner/company/PL7743262787/document/3ef0ef64-4d2f-4d12-bf89-8f836511da9b',
                        type: 'pragma',
                    },
                ],
                loanAmountChange: false,
            },
        ],
        agreements: agreementsCommon,
        transfers: [],
        offers: [],
    }, config: configCommon });
